import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  static values = {
    url: String,
    type: String,
    id: Number,
    bookmarked: { type: Boolean, default: false },
    outlineUrl: String,
    filledUrl: String
  }

  async toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.element.disabled) return

    this.element.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        credentials: "same-origin",
        body: JSON.stringify({
          bookmarkable_type: this.typeValue,
          bookmarkable_id: this.idValue
        })
      })

      const data = await response.json()
      if (!response.ok || !data.success) return

      this.syncMatchingButtons(data)
      window.dispatchEvent(new CustomEvent("workplace-bookmark:changed", { detail: data }))
    } catch (error) {
      console.error("Failed to toggle bookmark:", error)
    } finally {
      this.element.disabled = false
    }
  }

  syncMatchingButtons(data) {
    const key = `${data.bookmarkable_type}-${data.bookmarkable_id}`

    document.querySelectorAll(`[data-bookmark-key="${key}"]`).forEach((button) => {
      const controller = this.application.getControllerForElementAndIdentifier(button, "workplace--bookmark")
      controller?.applyState(data.bookmarked)
    })
  }

  applyState(bookmarked) {
    this.bookmarkedValue = bookmarked
    this.element.classList.toggle("is-saved", bookmarked)
    this.element.setAttribute("aria-pressed", bookmarked ? "true" : "false")

    const title = this.itemTitle
    this.element.setAttribute(
      "aria-label",
      bookmarked ? `Remove bookmark from ${title}` : `Bookmark ${title}`
    )

    if (this.hasIconTarget) {
      this.iconTarget.src = bookmarked ? this.filledUrlValue : this.outlineUrlValue
    }
  }

  get itemTitle() {
    const label = this.element.getAttribute("aria-label") || ""
    return label.replace(/^(Bookmark|Remove bookmark from)\s+/, "") || "this item"
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
